import { useTenantNavigate } from '@app-store'
import {
  getLayoutByEntityIdAndTypeApi,
  hideLoader,
  showLoader,
  updateEntityName,
} from '@app-store'
import View360RowRender from '../components/view-360/View360RowRender'
import { useParams } from 'react-router-dom'
import { AgentDeskParams } from '../types/params.types'
import { LAYOUT_TYPE_NAMESPACE, VIEW_360_CONSTANTS } from '../utils/constants'
import { useEffect, useState } from 'react'
import { EntityLayout } from '../types/layout.types'
import { CustomButton, SvgEdit } from '@ui-kit'
import { STRINGS } from '../utils/strings'
import { editRoute, entityRoute } from '../routes/route.constant'
import { useAppDispatch } from '../utils/agent.store'
import { TOASTER_NAMESPACE } from '../constants/addEditPage.strings'

const View360Record = () => {
  const [json, setJson] = useState<EntityLayout>()
  const { entityId, id } = useParams<AgentDeskParams>()
  const dispatch = useAppDispatch()
  const navigate = useTenantNavigate()
  const [isLayout, setIsLayout] = useState<boolean>(false)

  const get360Layout = async () => {
    try {
      dispatch(showLoader())
      const response = await getLayoutByEntityIdAndTypeApi({
        entityId: entityId,
        type: LAYOUT_TYPE_NAMESPACE.VIEW_360_TYPE,
      })

      if (response?.data) {
        setJson(response?.data?.[0])
        setIsLayout(true)
        dispatch(
          updateEntityName({ entityName: response.data[0]?.entity_name })
        ) // meta data for bread crumb
      }
      dispatch(hideLoader())
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    get360Layout()
  }, [entityId])

  return (
    <div className="h-full">
      {isLayout ? (
        <div className="w-full">
          <div className="flex justify-between items-center align-middle font-medium">
            <span className="font-primary text-base">{json?.name}</span>
            <div className="flex gap-2 flex-row-reverse">
              <CustomButton
                isFilled
                onClick={() => {
                  navigate(`/${entityRoute}/${entityId}/${editRoute}/${id}`)
                }}
                dataQaId={STRINGS?.QA_360_EDIT}
              >
                <div className="flex items-center gap-2">
                  <SvgEdit color="#FFFFFF" />
                  {STRINGS?.EDIT}
                </div>
              </CustomButton>
              <CustomButton
                onClick={() => navigate(-1)}
                dataQaId={STRINGS?.QA_360_BACK}
              >
                <div>{STRINGS?.BACK}</div>
              </CustomButton>
            </div>
          </div>
          <div className="flex bg-accent-0 w-full h-full pt-6">
            {json?.config === VIEW_360_CONSTANTS?.TWENTYSIXTY ? (
              <div className="flex h-full w-full">
                {json?.layout_data?.pages?.map((page, index) => (
                  <div
                    className={`flex flex-col h-full hide-scrollbar border border-tertiary-200 ${
                      index % 2 === 0 ? 'w-[20%] mx-0' : 'w-[60%] mx-5'
                    }`}
                    style={{
                      width: index % 2 === 0 ? '20%' : '60%',
                      backgroundColor:
                        index % 2 === 0 ? json?.layout_data?.color : '#F6F6F6',
                    }}
                    key={`${page?.pageId}-${index}`}
                  >
                    {page?.rows?.map((row, rowIndex) => (
                      <div
                        key={`${row?.rowId}-${rowIndex}`}
                        className="flex w-full"
                      >
                        <View360RowRender
                          row={row}
                          layout={json}
                          // middleCard={index % 2 !== 0} {/* TODO will review later */}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex h-full w-full">
                {json?.layout_data?.pages?.map((page, index) => (
                  <div
                    className={`flex flex-col h-full hide-scrollbar border border-tertiary-200 ${
                      index % 2 === 0 ? 'w-[25%] mx-0' : 'w-[50%] mx-5'
                    }`}
                    style={{
                      width: index % 2 === 0 ? '25%' : '50%',
                      backgroundColor:
                        index % 2 === 0 ? json?.layout_data?.color : '#F6F6F6',
                    }}
                    key={`${page?.pageId}-${index}`}
                  >
                    {page?.rows?.map((row, rowIndex) => (
                      <div
                        key={`${row?.rowId}-${rowIndex}`}
                        className="flex w-full"
                      >
                        <View360RowRender
                          row={row}
                          layout={json}
                          // middleCard={index % 2 !== 0} {/* TODO will review later */}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <span className="font-primary text-base">
            {TOASTER_NAMESPACE.LAYOUT_NOT_CREATED}
          </span>
        </div>
      )}
    </div>
  )
}

export default View360Record
